const map = {
  "//localhost:9091/mall/": `//${(top || window).location.host}/mall/`,
  "//localhost:9091/spms/": `//${(top || window).location.host}/spms/`,
};

export default function hostMap(host) {
  if (process.env.NODE_ENV === "production") return map[host];
  return host;
}
